import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { api, ApiFailure } from "../lib/api";
import { Icon } from "../components/Icon";
import { PublicFrame } from "./Signup";

// Owner-account recovery, finished by the owner. A Delta administrator starts it after checking who the owner is;
// the code goes to the mobile or email already on record. Without that code nothing changes.

export function Recover() {
  const { t } = useLang();
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (!/^05\d{8}$/.test(phone.trim())) { setErr(t("fieldMobileFormat")); return; }
    if (!/^\d{6}$/.test(code.trim())) { setErr(t("sstCodeInvalid")); return; }
    if (pw.length < 10 || !/\d/.test(pw) || !/[A-Za-z؀-ۿ]/.test(pw)) { setErr(t("fieldPasswordRule")); return; }
    setBusy(true);
    try {
      await api("POST", "/recovery/complete", { phone: phone.trim(), code: code.trim(), password: pw });
      setDone(true);
    } catch (x) {
      setErr(x instanceof ApiFailure ? x.code === "too_many_attempts" ? t("signupTooMany") : x.code === "validation" ? t("fieldPasswordRule") : t("recoverInvalid") : t("serverError"));
      setPw("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <PublicFrame title={t("recoverTitle")} lede={t("recoverLede")}>
      {done ? (
        <div className="su-status"><div className="dlg-alert show" role="status" data-testid="recover-done"><Icon name="check" /><span>{t("recoverDone")}</span></div>
          <Link className="btn btn-primary" to="/login">{t("sstGoSignIn")}</Link></div>
      ) : (
        <form noValidate onSubmit={submit}>
          <div className="field"><label htmlFor="rc-m">{t("recoverMobile")}</label>
            <input id="rc-m" className="control num" dir="ltr" style={{ textAlign: "start" }} type="tel" autoComplete="username" placeholder={t("mobilePh")} value={phone} onChange={(e) => setPhone(e.target.value)} /></div>
          <div className="field"><label htmlFor="rc-c">{t("recoverCode")}</label>
            <input id="rc-c" className="control num" inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} /></div>
          <div className="field"><label htmlFor="rc-p">{t("recoverPassword")}</label>
            <input id="rc-p" className="control" type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} />
            <span className="hint">{t("signupPasswordHint")}</span></div>
          {err && <div className="dlg-alert show" role="alert"><Icon name="alert" /><span>{err}</span></div>}
          <button className="btn btn-primary" type="submit" disabled={busy}>{t("recoverSubmit")}</button>
        </form>
      )}
      <p className="login-alt"><Link to="/login">{t("signupSignIn")}</Link></p>
    </PublicFrame>
  );
}
